<div class="card card-custom">
  <div class="card-header px-5">
    <div class="card-title">
      <h3 class="card-label">
        Comment
        {{
          comments[0].rev_type === 'MOD'
            ? 'Edited'
            : comments[0].rev_type === 'ADD'
            ? 'Added'
            : 'Deleted'
        }}
      </h3>
    </div>
  </div>
  <div class="card-body d-flex align-items-start p-5">
    <kt-user-photo
      [size]="40"
      [type]="'object'"
      [editable]="false"
      [user$]="comments[0]"
    ></kt-user-photo>
    <div class="d-flex flex-column flex-grow-1 font-size-md text-dark-75 ml-3">
      <div style="height: 46px" class="d-flex font-weight-bold align-items-center">
        {{ comments[0].username }}
      </div>
      <div>
        <div class="bg-light mb-1 p-1" [class.text-muted]="comments[0].rev_type === 'DEL'">
          {{ comments[0].comment }}
        </div>
        <div class="text-muted font-size-xs">{{ getFormattedDate(comments[0].rev_timestamp) }}</div>
      </div>
      <div *ngIf="comments[0].rev_type === 'MOD'" class="mt-3 ml-5">
        <div class="bg-light text-muted mb-1 p-1">{{ comments[1].comment }}</div>
        <div class="text-muted font-size-xs">{{ getFormattedDate(comments[1].rev_timestamp) }}</div>
      </div>
    </div>
  </div>
  <div class="card-footer d-flex justify-content-end p-5">
    <button type="button" mat-raised-button (click)="close()">
      <span translate="GLOBAL.CLOSE">Close</span>
    </button>
  </div>
</div>
